var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.921875,
    y: 0.876953,
    width: 44.0934,
    height: 42.9911,
    rx: 21.4955,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 22.3726C22.9688 21.3603 23.3709 20.3894 24.0867 19.6736C24.8025 18.9578 25.7733 18.5557 26.7856 18.5557C27.798 18.5557 28.7688 18.9578 29.4846 19.6736C30.2004 20.3894 30.6025 21.3603 30.6025 22.3726C30.6025 23.3849 30.2004 24.3557 29.4846 25.0715C28.7688 25.7873 27.798 26.1895 26.7856 26.1895C25.7733 26.1895 24.8025 25.7873 24.0867 25.0715C23.3709 24.3557 22.9688 23.3849 22.9688 22.3726V22.3726Z",
    fill: "#1ABCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3359 30.0064C15.3359 28.994 15.7381 28.0232 16.4539 27.3074C17.1697 26.5916 18.1405 26.1895 19.1528 26.1895H22.9697V30.0064C22.9697 31.0187 22.5676 31.9895 21.8518 32.7053C21.136 33.4211 20.1651 33.8233 19.1528 33.8233C18.1405 33.8233 17.1697 33.4211 16.4539 32.7053C15.7381 31.9895 15.3359 31.0187 15.3359 30.0064V30.0064Z",
    fill: "#0ACF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 10.9219V18.5557H26.7856C27.798 18.5557 28.7688 18.1535 29.4846 17.4377C30.2004 16.7219 30.6025 15.7511 30.6025 14.7388C30.6025 13.7265 30.2004 12.7556 29.4846 12.0398C28.7688 11.324 27.798 10.9219 26.7856 10.9219H22.9688Z",
    fill: "#FF7262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3359 14.7388C15.3359 15.7511 15.7381 16.7219 16.4539 17.4377C17.1697 18.1535 18.1405 18.5557 19.1528 18.5557H22.9697V10.9219H19.1528C18.1405 10.9219 17.1697 11.324 16.4539 12.0398C15.7381 12.7556 15.3359 13.7265 15.3359 14.7388V14.7388Z",
    fill: "#F24E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3359 22.3726C15.3359 23.3849 15.7381 24.3557 16.4539 25.0715C17.1697 25.7873 18.1405 26.1895 19.1528 26.1895H22.9697V18.5557H19.1528C18.1405 18.5557 17.1697 18.9578 16.4539 19.6736C15.7381 20.3894 15.3359 21.3603 15.3359 22.3726V22.3726Z",
    fill: "#A259FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.deccaba17b322f3c71f0bea224effc21.svg";
export { ForwardRef as ReactComponent };